// Hover hotspots for the light diagrams: [x%, y%, w%, h%, title, note]
export const SPOTS = {
  upi: [
    [6, 8, 19, 12, "P2P", "Person-to-person transfers between two accounts."],
    [6, 23, 19, 12, "P2M", "Payments from a customer to a merchant."],
    [6, 37, 19, 12, "Collect", "A payee requests money; the payer approves it."],
    [6, 51, 19, 12, "Mandate", "Recurring payments the customer authorises once."],
    [6, 65, 19, 12, "Refund", "Full or partial money back, capped at the original amount."],
    [6, 80, 19, 12, "Status", "Ask the partner for the real outcome of an uncertain payment."],
    [39, 33, 21, 34, "SwitchX Core", "Creates a durable record for every request and drives its state."],
    [75, 12, 18, 20, "Validate", "Checks format, amount and institution rights before routing."],
    [75, 39, 18, 21, "Route", "Picks the best eligible partner using versioned rules."],
    [75, 65, 18, 22, "Track", "Follows each payment to success, failure or pending verification."],
  ],
  routing: [
    [9, 43, 18, 13, "Request", "An incoming payment with its type, amount and institution."],
    [38, 42, 22, 15, "Routing Engine", "Applies rules in priority order, then partner health and weights."],
    [70, 23, 22, 9, "Partner A", "Gets the largest share of traffic while it stays healthy."],
    [70, 38, 22, 9, "Partner B", "Shares traffic by weight with the other eligible partners."],
    [70, 52, 22, 9, "Partner C", "Gets a small share, useful for gradual roll-outs."],
    [70, 67, 22, 11, "Partner Down", "Unhealthy partners are skipped automatically."],
  ],
  recon: [
    [7, 24, 24, 21, "SwitchX Records", "Your internal transaction ledger for the day."],
    [7, 56, 24, 18, "Partner File", "The partner's report, read with a saved column mapping."],
    [39, 38, 22, 22, "Match Engine", "Matches by reference, amount and status in exact paise."],
    [69, 17, 24, 16, "Matched", "Both sides agree. This does not by itself prove settlement."],
    [69, 40, 24, 18, "Exceptions", "Differences go to a queue with an owner and notes."],
    [69, 63, 24, 20, "Settlement Report", "Expected against reported amounts and fees per batch."],
  ],
  onboard: [
    [43, 27, 15, 6, "Consent recorded", "Every consent is stored with time and version."],
    [9, 37, 17, 29, "Apply", "Guided form that saves as you go."],
    [26, 37, 17, 29, "KYC Documents", "Secure uploads with versions and reviewer notes."],
    [43, 37, 17, 29, "Maker Review", "An operator prepares and checks the case."],
    [60, 37, 17, 29, "Checker Approval", "A different person approves, so no one signs off their own work."],
    [77, 37, 17, 29, "Account / QR Live", "Activated only after every control passes."],
  ],
  risk: [
    [40, 9, 20, 17, "Failure rate", "Share of failed payments per partner and institution."],
    [36, 32, 29, 38, "Monitoring", "One live view of volumes, errors and stuck payments."],
    [12, 39, 18, 23, "Alerts", "Acknowledge, assign, investigate and resolve. Every step is audited."],
    [70, 39, 19, 22, "Latency p95", "How long the slowest 5% of requests take."],
    [40, 78, 20, 15, "Partner health", "Health checks that feed routing decisions."],
  ],
  dev: [
    [12, 9, 16, 22, "REST API", "Documented endpoints with an OpenAPI reference."],
    [32, 9, 16, 22, "Webhooks", "Events pushed to your server as payments change state."],
    [52, 9, 16, 22, "Sandbox", "Force success, decline, timeout or partner error. No real money."],
    [72, 9, 16, 22, "Docs", "Guides, schemas and troubleshooting tips."],
    [41, 38, 18, 24, "Developer Platform", "One place to build, test and monitor your integration."],
    [17, 72, 18, 18, "Idempotency", "Retries return the stored answer instead of paying twice."],
    [40, 72, 19, 18, "Signed Events", "HMAC signatures with timestamps stop forged or replayed events."],
    [64, 72, 19, 18, "Error Codes", "Typed codes and correlation IDs for quick support."],
  ],
  channels: [
    [14, 21, 19, 19, "Mobile banking", "Payments and onboarding inside your mobile app."],
    [41, 7, 19, 22, "Internet banking", "The same journeys on the web, through the same APIs."],
    [70, 20, 21, 20, "Merchant app", "Merchants collect payments and track settlements."],
    [38, 40, 22, 18, "SwitchX Core", "Every channel calls the same services, so you launch once."],
    [11, 52, 21, 24, "Branch", "Staff-assisted onboarding with maker-checker review."],
    [43, 69, 20, 22, "POS", "Card terminals onboarded as a merchant product."],
    [70, 53, 22, 22, "QR payments", "Static and dynamic QR for merchants of any size."],
  ],
  controls: [
    [23, 10, 18, 22, "Maker-checker", "One person prepares, a different person approves."],
    [59, 10, 18, 22, "Audit trail", "Append-only log of who did what, and when."],
    [11, 40, 16, 21, "MFA", "Authenticator codes for every privileged role."],
    [40, 32, 20, 35, "Built-in controls", "Security rules enforced on the server for every request."],
    [72, 40, 17, 21, "Data isolation", "Each institution only ever sees its own data."],
    [25, 67, 17, 22, "Consent", "Customer consents stored with time and version."],
    [58, 67, 20, 22, "Data minimisation", "No UPI PINs, OTPs or bank passwords are ever stored."],
  ],
  data: [
    [8, 20, 17, 14, "Partner health", "Spot a struggling partner before it hurts customers."],
    [8, 35, 17, 15, "Failure patterns", "See which errors repeat, where and when."],
    [8, 52, 17, 15, "Latency trends", "Track response times by partner and hour."],
    [8, 70, 17, 15, "Reconciliation gaps", "Find records that don't match the partner's file."],
    [32, 17, 27, 16, "Transactions", "Every request arrives with an idempotency key."],
    [67, 17, 25, 16, "Validation", "Format, amount and authorisation checks."],
    [32, 42, 27, 17, "Routing", "The best eligible partner, chosen by rules and health."],
    [32, 70, 27, 16, "Insights", "Signals built from every transaction trace."],
    [67, 70, 25, 17, "Decisions", "Your team tunes routing, limits and partners with evidence."],
  ],
};
